import angular from 'angular';
import template from './mobile-doctor-actions.html';
class GroupCallMobileDoctorActionsController {
    constructor() { }
    $onInit() { }
}
const groupCallMobileDoctorActions = {
    template,
    bindings: {
        onToggleAudio: '&',
        hasAudio: '&',
        activeVideoProvider: '<',
    },
    controller: GroupCallMobileDoctorActionsController,
};
export default angular
    .module('doxy.videoChat.callFrames.selfVideoFrame.selfVideoFrameFull.actions.groupCall.mobileDoctorActions', [])
    // group-call-mobile-doctor-actions
    .component('groupCallMobileDoctorActions', groupCallMobileDoctorActions).name;
